import angular from 'angular'

/**
 * A service that handles interactions between the onboarding and roster modules.
 */
export function OnboardingRosterService(employeeService) {
    'ngInject'
    // New employments default to the Sales Rep job title
    const DEFAULT_JOB_TITLE = 5;
    // New employments default to dept 400 Sales.
    const DEFAULT_DEPARTMENT = 3;
    // New employments default to Sales Rep role being enabled by default.
    const DEFAULT_ROLES = { 11: true };
    // New employments are always in Pending status by default.
    const DEFAULT_EMPLOYEE_STATUS = 3;

    return {
        createEmployeeFromOnboardingApplication: createEmployeeFromOnboardingApplication,
        retrieveOnboardingApplicationEmployee: retrieveOnboardingApplicationEmployee
    };

    /**
     * Create an employee that can be edited in the employee edit page
     * using data from the applicant of the given application.
     */
    function createEmployeeFromOnboardingApplication(onboardingApplication) {
        // Use the same starting point for the employee model as the employee edit page.
        return employeeService.retrieveNewEmployeeModel()
            .then(function (employee) {
                // Assign some default properties to the new employee.

                if (onboardingApplication.IsSelfSignUp) {
                    employee.EmployeeID = onboardingApplication.SelfSignUpEmployeeID;
                    employee.IsSelfSignUp = onboardingApplication.IsSelfSignUp
                }
                employee.FirstName = onboardingApplication.Applicant.FirstName;
                employee.LastName = onboardingApplication.Applicant.LastName;
                employee.UserName = employee.EmailAddress = onboardingApplication.Applicant.EmailAddress;
                // Always an empty object initially, so convert to an empty list.
                employee.GlobalRoles = [];

                const office = createOnboardingApplicationOfficeModel(onboardingApplication);
                employee.IcdOffices = [office];

                return employee;
            });
    }

    function createOnboardingApplicationOfficeModel(onboardingApplication) {

        return {
            EmployeeStatusID: DEFAULT_EMPLOYEE_STATUS, // Pending.
            IcdOfficeID: onboardingApplication.IcdOffice.Id,
            // Pre-set Job Title to Sales Rep
            JobTitleID: DEFAULT_JOB_TITLE,
            // Pre-set Department to 400 Sales
            CompensationProfileID: DEFAULT_DEPARTMENT,
            // Pre-enable Sales Rep role.
            Roles: angular.copy(DEFAULT_ROLES),
            // Pre-select the application division.
            Divisions: [
                onboardingApplication.Division.Id
            ],
            // Deprecated, but expected by the employee edit form.
            AdministeredModules: [],
            // Link the new employee to this onboarding application.
            OnboardingApplicationID: onboardingApplication.OnboardingApplicationID,
            OnboardingApplication: onboardingApplication,
            // Set time entry and payroll properties by default.
            IsOnPayroll: true,
            TimeClock: true,
            RequireBreak: true
        };
    }

    function retrieveOnboardingApplicationEmployee(onboardingApplication) {
        //If the application is self sign up then the user is directly from the DB instead of creating a new model
        return employeeService.retrieveEmployee(onboardingApplication.SelfSignUpEmployeeID)
            .then(function (employee) {
                // We don't want to reset the employee's password to its own hash.
                employee.Password = null;
                employee.IsSelfSignUp = onboardingApplication.IsSelfSignUp;
                employee.SelfSignUpEmployeeID = onboardingApplication.SelfSignUpEmployeeID;
                employee.EmployeeID = onboardingApplication.SelfSignUpEmployeeID;

                let employmentRecord = employee.IcdOffices[0];
                if (employmentRecord) {
                    employmentRecord.OnboardingApplicationID = onboardingApplication.OnboardingApplicationID;
                    // Auto-check fields that should only activate after adding to roster.
                    employmentRecord.TimeClock = true;
                    employmentRecord.RequireBreak = true;
                    employmentRecord.IsOnPayroll = true;
                } else {
                    employmentRecord = createOnboardingApplicationOfficeModel(onboardingApplication);
                    employee.IcdOffices = [employmentRecord];
                }
                return employee;
            });

    }
}
